package org.solyton.solawi.bid.module.distribution.`data`.management

import kotlin.Int
import kotlin.collections.List
import org.evoleq.axioms.definition.ReadOnly
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.compose.modal.Modals
import org.evoleq.device.`data`.Device
import org.evoleq.optics.lens.Lens
import org.evoleq.optics.storage.ActionDispatcher
import org.solyton.solawi.bid.module.context.`data`.Context
import org.solyton.solawi.bid.module.distribution.`data`.distributionpoint.DistributionPoint
import org.solyton.solawi.bid.module.i18n.`data`.Environment
import org.solyton.solawi.bid.module.i18n.`data`.I18N

/**
 * Autogenerated Lens.
 * Read and manipulate [DistributionManagement.context]
 */
@ReadWrite
public val context: Lens<DistributionManagement, Context> by lazy {
      Lens(
        get = { whole -> whole.context },
        set = { part -> { whole -> whole.copy(context = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [DistributionManagement.context]
 */
@ReadWrite
public fun DistributionManagement.context(`set`: Context.() -> Context): DistributionManagement =
    copy(context = set(context))

/**
 * Autogenerated ReadOnly Lens.
 * Read [DistributionManagement.actions]
 */
@ReadOnly
public val actions: Lens<DistributionManagement, ActionDispatcher<DistributionManagement>> by lazy {
      Lens(
        get = { whole -> whole.actions },
        set = { { it } }
      )}


/**
 * Autogenerated ReadOnly Lens.
 * Read [DistributionManagement.environment]
 */
@ReadOnly
public val environment: Lens<DistributionManagement, Environment> by lazy {
      Lens(
        get = { whole -> whole.environment },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [DistributionManagement.deviceData]
 */
@ReadWrite
public val deviceData: Lens<DistributionManagement, Device> by lazy {
      Lens(
        get = { whole -> whole.deviceData },
        set = { part -> { whole -> whole.copy(deviceData = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [DistributionManagement.deviceData]
 */
@ReadWrite
public fun DistributionManagement.deviceData(`set`: Device.() -> Device): DistributionManagement =
    copy(deviceData = set(deviceData))

/**
 * Autogenerated Lens.
 * Read and manipulate [DistributionManagement.modals]
 */
@ReadWrite
public val modals: Lens<DistributionManagement, Modals<Int>> by lazy {
      Lens(
        get = { whole -> whole.modals },
        set = { part -> { whole -> whole.copy(modals = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [DistributionManagement.modals]
 */
@ReadWrite
public fun DistributionManagement.modals(`set`: Modals<Int>.() -> Modals<Int>):
    DistributionManagement = copy(modals = set(modals))

/**
 * Autogenerated Lens.
 * Read and manipulate [DistributionManagement.i18n]
 */
@ReadWrite
public val i18n: Lens<DistributionManagement, I18N> by lazy {
      Lens(
        get = { whole -> whole.i18n },
        set = { part -> { whole -> whole.copy(i18n = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [DistributionManagement.i18n]
 */
@ReadWrite
public fun DistributionManagement.i18n(`set`: I18N.() -> I18N): DistributionManagement = copy(i18n =
    set(i18n))

/**
 * Autogenerated Lens.
 * Read and manipulate [DistributionManagement.distributionPoints]
 */
@ReadWrite
public val distributionPoints: Lens<DistributionManagement, List<DistributionPoint>> by lazy {
      Lens(
        get = { whole -> whole.distributionPoints },
        set = { part -> { whole -> whole.copy(distributionPoints = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [DistributionManagement.distributionPoints]
 */
@ReadWrite
public
    fun DistributionManagement.distributionPoints(`set`: List<DistributionPoint>.() -> List<DistributionPoint>):
    DistributionManagement = copy(distributionPoints = set(distributionPoints))

/**
 * Autogenerated Lens.
 * Read and manipulate [DistributionManagement.personalDistributionPoints]
 */
@ReadWrite
public val personalDistributionPoints: Lens<DistributionManagement, List<DistributionPoint>> by
    lazy {
      Lens(
        get = { whole -> whole.personalDistributionPoints },
        set = { part -> { whole -> whole.copy(personalDistributionPoints = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [DistributionManagement.personalDistributionPoints]
 */
@ReadWrite
public
    fun DistributionManagement.personalDistributionPoints(`set`: List<DistributionPoint>.() -> List<DistributionPoint>):
    DistributionManagement = copy(personalDistributionPoints = set(personalDistributionPoints))
